import React from 'react';
import { useSelector } from 'react-redux';
import HeaderApp from '../components/HeaderApp';
const AppHome = () => {
    const state= useSelector(state => state.user)

    return (
        <div>
            <HeaderApp />
        </div>
    );
};

export default AppHome;